import { withIcon } from './withIcon';

const TransferSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8327 4.88125L11.8327 0.881172C11.6095 0.658043 11.2476 0.65811 11.0245 0.881306C10.9174 0.98845 10.8572 1.1337 10.8572 1.28521V2.99952H6.85713C6.54152 2.99952 6.28568 3.25536 6.28568 3.57097C6.28568 3.88658 6.54152 4.14242 6.85713 4.14242H11.4287C11.7443 4.14242 12.0001 3.88658 12.0001 3.57097V2.66463L14.6207 5.28525L12.0001 7.90587V6.99956C12.0001 6.68395 11.7443 6.42811 11.4287 6.42811H5.14281V4.7138C5.14275 4.39819 4.88684 4.14242 4.57126 4.14249C4.41979 4.14252 4.27451 4.20269 4.16736 4.3098L0.167321 8.30987C-0.0557738 8.53304 -0.0557738 8.89475 0.167321 9.11788L4.1674 13.118C4.27454 13.2251 4.41986 13.2854 4.5714 13.2854C4.6465 13.2856 4.72093 13.2709 4.79024 13.242C5.00373 13.1534 5.14288 12.9451 5.14281 12.714V10.9996H9.14289C9.4585 10.9996 9.71434 10.7438 9.71434 10.4282C9.71434 10.1126 9.4585 9.85674 9.14289 9.85674H4.5714C4.25579 9.85674 3.99995 10.1126 3.99995 10.4282V11.3345L1.37933 8.71387L3.99995 6.09325V6.99956C3.99995 7.31517 4.25579 7.57101 4.5714 7.57101H10.8572V9.28532C10.8573 9.60093 11.1132 9.85671 11.4288 9.85664C11.5802 9.85661 11.7255 9.79644 11.8327 9.68933L15.8327 5.68925C16.0558 5.46609 16.0558 5.10438 15.8327 4.88125Z"
      fill="currentColor"
    />
  </svg>
);

export const Transfer = withIcon(TransferSvg);
